import {FC} from 'react';

import {useTranslation} from 'react-i18next';

import {
  Dialog,
  DialogProps,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';

import {EmpionButton} from '../EmpionButton/EmpionButton';

interface ConfirmDeleteDialogProps {
  dialogContent: string;
  handleConfirm: () => void;
  handleCancel: () => void;
}

export const ConfirmDeleteDialog: FC<ConfirmDeleteDialogProps & DialogProps> = ({
  dialogContent,
  handleConfirm,
  handleCancel,
  ...props
}) => {
  const {t} = useTranslation();

  return (
    <Dialog
      {...props}
      sx={{
        '& .MuiDialog-paper': {
          backgroundColor: 'background.default',
          backgroundImage: 'none',
        },
        ...props.sx,
      }}
    >
      <DialogTitle id='alert-dialog-title'>
        <Typography variant='h3' component={'span'}>
          {t('shared.dialogs.confirmation.title')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          <Typography variant='body1' component={'span'}>
            {dialogContent}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{padding: '16px'}}>
        <EmpionButton type='button' variant='secondary' onClick={handleCancel}>
          {t('shared.formButtons.cancel')}
        </EmpionButton>
        <EmpionButton type='button' variant='primary' onClick={handleConfirm}>
          {t('shared.formButtons.confirm')}
        </EmpionButton>
      </DialogActions>
    </Dialog>
  );
};
